import { useMemo } from 'react';

import { getLeftRightAxisTypes } from '../grouped-chart/utils';
import { alignScale, getValueScale } from '../grouped-chart/utils/scale';
import { GroupedTimeSeriesData, TimeSeriesData } from '../grouped-chart/types';

type Props = {
  data: TimeSeriesData | GroupedTimeSeriesData;
  height: number;
  padding: number;
  numTicks: number;
  stacked?: boolean;
};

export const useValueScales = (props: Props) => {
  const { data, height, padding, numTicks, stacked = false } = props;
  const axisTypes = getLeftRightAxisTypes(data.series);
  const leftValueScale = useMemo(
    () =>
      getValueScale(
        {
          type: 'data',
          chartData: data,
        },
        stacked,
        'left',
        padding,
        [height, 0],
        numTicks,
        axisTypes.left === 'Integer' ? 1 : undefined,
      ),
    [axisTypes.left, height, data, numTicks, stacked, padding],
  );
  const rightValueScale = useMemo(
    () =>
      alignScale(
        getValueScale(
          {
            type: 'data',
            chartData: data,
          },
          stacked,
          'right',
          padding,
          [height, 0],
          numTicks,
          axisTypes.right === 'Integer' ? 1 : undefined,
        ),
        leftValueScale,
        numTicks,
        axisTypes.right === 'Integer' ? 1 : undefined,
      ),
    [axisTypes.right, height, data, leftValueScale, numTicks, stacked, padding],
  );
  const valueScales = useMemo(
    () => ({
      left: leftValueScale,
      right: rightValueScale,
    }),
    [leftValueScale, rightValueScale],
  );

  return valueScales;
};
